import { FOLDER_ANCESTORS_FRAGMENT } from './fragments'
import { gql } from 'graphql-request'

export const GET_PRESET_LINK = gql`
  query getPresetLink($batchId: ID) {
    presetLink(batchId: $batchId) {
      redirectValue
      redirectType
    }
  }
`
export const GET_IS_COLLECTIBLE_BATCH = gql`
  query getIsCollectible($flowcodeId: ID, $batchId: ID) {
    collectible(flowcodeId: $flowcodeId, batchId: $batchId) {
      isCollectible
      redirectType
      redirectValue
    }
  }
`

export const GET_FLOWTAGS_QUERY = gql`
  query getflowtags($first: Int, $after: String, $creationSource: String) {
    me {
      flowcodes(first: $first, after: $after, creationSource: $creationSource) {
        pageInfo {
          startCursor
          endCursor
          hasNextPage
        }
        edges {
          node {
            id
            nickname
            activeLink {
              redirectValue
              shorturl
            }
          }
        }
      }
    }
  }
`

export const GET_FLOWTAG_COUNT = gql`
  query getUserInfo {
    me {
      flowtagCount
    }
  }
`

export const SEARCH_FLOWCODE_ASSET_LABELS_QUERY = gql`
  query getAssetLabels(
    $isRecommended: Boolean = false
    $offset: Int
    $before: String
    $after: String
    $first: Int = 15
    $last: Int
    $name_Icontains: String
  ) {
    assetLabels(
      isRecommended: $isRecommended
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      name_Icontains: $name_Icontains
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          name
        }
      }
    }
  }
`

export const GET_FOLDER_ANCESTORS = gql`
  query getFolderAncestors($directoryId: ID!) {
    directory(directoryId: $directoryId) {
      id
      name
      batchCount
      ancestors {
        ...FolderAncestors
      }
    }
  }
  ${FOLDER_ANCESTORS_FRAGMENT}
`

export const GET_FOLDER_CHILDREN = gql`
  query getFolderChildren(
    $parentDirectoryId: ID
    $first: Int
    $orderBy: String = "name"
    $after: String
  ) {
    directories(parentDirectoryId: $parentDirectoryId, orderDirs: $orderBy) {
      allDirs(first: $first, after: $after) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        edges {
          node {
            name
            id
            descendantCount
            parent {
              name
              id
            }
          }
        }
      }
    }
  }
`

export const GET_DOMAIN_MANAGEMENT_DETAILS = gql`
  query getDomainManagementDetails {
    domainManagementDetails {
      id
      domain
      type
      deletedAt
      flowcodeSubdomains {
        id
        domain
        timestamp
        isVerified
        deletedAt
      }
      flowpageSubdomains {
        id
        domain
        timestamp
        isVerified
        deletedAt
      }
    }
  }
`

export const FLOWPAGE_FLOWCODE_DOWNLOAD_DETAILS = gql`
  query flowpageFlowcodeDownloadDetails($id: ID!) {
    batch(batchId: $id) {
      archived
      studioConfig {
        id
        configuration
      }
      activeLink {
        shorturl
      }
    }
  }
`

export const GET_FLOWCODE_SUBDOMAINS = gql`
  query whiteLabelRedirectDomains {
    whiteLabelRedirectDomains {
      domain
      id
      isCoBranded
      isDefault
      timestamp
    }
  }
`

export const GET_REDIRECT_SUBDOMAIN_PERMISSIONS = gql`
  query getRedirectSubdomainPermissions($subdomainIds: [UUID]) {
    redirectSubdomainPermissions(subdomainIds: $subdomainIds) {
      assetId
      result {
        success
        error
      }
      entityPermissions {
        entityId
        entityType
        permissionName
        entityName
      }
    }
  }
`

export const GET_BATCHES_FOR_SUBDOMAINS = gql`
  query getBatchesForSubdomains($subdomainIds: [UUID]) {
    batchesForSubdomains(subdomainIds: $subdomainIds) {
      id
    }
  }
`

export const FLOWCODE_COUNT_QUERY = gql`
  query flowcodeCount {
    me {
      flowcodeCount
    }
  }
`

export const PRINT_STORE_TEMP_PREVIEW_IMAGE_URL = gql`
  query printStoreTempPreviewImageUrl($dhProjectId: String!, $format: ExportFormat) {
    getTemporaryImageUrl(dhProjectId: $dhProjectId, format: $format) {
      imageUrl
    }
  }
`

export const GET_ARCHIVED_FLOWCODES_COUNT = /* GraphQL */ `
  query CodeManagement($allbatchesArchived: Boolean = true, $pageType: PageType) {
    myFlowcodes(allbatchesArchived: $allbatchesArchived, pageType: $pageType) {
      allBatches {
        totalCount
      }
    }
  }
`

export const GET_DISPLAY_TO_ALL_FLOWCODE_TEMPLATES = gql`
  query displayToAllFlowcodeTemplates(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $nameIstartswith: String
    $nameIcontains: String
    $id: UUID
    $publishedOnIsnull: Boolean
    $source: String
    $orderBy: String
  ) {
    defaultFlowcodeTemplates(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      name_Istartswith: $nameIstartswith
      name_Icontains: $nameIcontains
      id: $id
      publishedOn_Isnull: $publishedOnIsnull
      source: $source
      orderBy: $orderBy
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          configuration
          displayToAll
          isCustomizable
          source
        }
        cursor
      }
      totalCount
    }
  }
`

export const GET_ASSIGNED_FLOWCODE_TEMPLATES = gql`
  query getAssignedFlowcodeTemplates(
    $entityTypesFilter: [EntityTypes]
    $includeDefaultTemplates: Boolean
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $nameIstartswith: String
    $nameIcontains: String
    $id: UUID
    $publishedOnIsNull: Boolean
    $source: String
    $orderBy: String
    $isCustomizable: Boolean
  ) {
    assignedFlowcodeTemplates(
      entityTypesFilter: $entityTypesFilter
      includeDefaultTemplates: $includeDefaultTemplates
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      name_Istartswith: $nameIstartswith
      name_Icontains: $nameIcontains
      id: $id
      publishedOn_Isnull: $publishedOnIsNull
      source: $source
      orderBy: $orderBy
      isCustomizable: $isCustomizable
    ) {
      edges {
        node {
          id
          name
          configuration
          assetFile {
            id
            assetName
          }
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`

export const GET_USER_SAVED_FLOWCODE_TEMPLATES = gql`
  query getUserSavedFlowcodeTemplates(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $orderBy: String
  ) {
    userSavedFlowcodeTemplates(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      orderBy: $orderBy
    ) {
      edges {
        node {
          id
          name
          configuration
          timeStamp
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`

export const GET_NESTED_DIRECTORIES = gql`
  query allNestedDirectories {
    allNestedDirectories {
      nestedDirs {
        name
        id
        isRoot
        children {
          name
          id
        }
      }
    }
  }
`

export const GET_FLOWCODE_TEMPLATES_COUNT = gql`
  query getFlowcodeTemplatesCount(
    $entityTypesFilter: [EntityTypes]
    $includeDefaultTemplates: Boolean
    $isCustomizable: Boolean
  ) {
    userSavedFlowcodeTemplates {
      totalCount
    }
    assignedFlowcodeTemplates(
      entityTypesFilter: $entityTypesFilter
      includeDefaultTemplates: $includeDefaultTemplates
      isCustomizable: $isCustomizable
    ) {
      totalCount
    }
  }
`
